import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import Loading from "components/Loading";
import Form from "components/Form";
import useId from "hooks/useId";
import {makeStyles} from "@material-ui/core";
import VS from "constants/ValidationShema";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import TextInput from "components/TextInput";
import DatePicker from "components/DatePicker";
import {connect} from "react-redux";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";

const useStyle = makeStyles(theme => ({
    wrap: {
        minWidth: 600,
        minHeight: 40
    }
}));


function PapersGeneratorGzmManagementResolution(
    {
        groupId,
        paper,
        onClose,
        formSubmit
    }) {

    const classes = useStyle();
    const [initData, setInitData] = useState(null)
    const [working, setWorking] = useState(null)

    useEffect(() => {
        PurchasingGroupStage1Service.getGzmManagementResolution(groupId).then(resp => {
            if (resp) {
                setInitData(resp);
            } else {
                onClose();
            }
        });
        // eslint-disable-next-line
    }, [groupId])

    const formId = useId();
    const onSubmit = (values) => {
        setWorking(true);
        PurchasingGroupStage1Service.printGzmManagementResolution(groupId, values).finally(onClose)
    }


    const getActions = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onClose, 'outlined', working));
        buttons.push(createButton(Tr('generate_paper'), () => formSubmit[formId](), undefined, working, undefined, working));
        return <MultiButton buttons={buttons}/>;
    }
    return (
        <Dialog
            open
            title={paper.name}
            titleCentered
            maxWidth="md"
            fullWidth={false}
            onClose={onClose}
            dialogActions={getActions()}
        >
            <div className={classes.wrap}>
                {
                    !initData ?
                        <Loading/> :
                        <>
                            <Form
                                initialValues={initData}
                                validationSchema={VS.object({
                                    resolutionNumber: VS.stringMaxNoRq(50),
                                    resolutionDate: VS.dateTimeNoReq(),
                                    projectName: VS.stringMaxNoRq(200)
                                })}
                                onSubmit={onSubmit}
                                id={formId}
                            >
                                {(formikProps) => (<>
                                        <TextInput
                                            id="resolutionNumber"
                                            label={Tr("resolution_number")}
                                            formikProps={formikProps}
                                            disabled={working}
                                            limit={50}
                                        />

                                        <DatePicker
                                            id="resolutionDate"
                                            label={Tr('resolution_date')}
                                            formikProps={formikProps}
                                            disabled={working}
                                        />

                                        <TextInput
                                            id="projectName"
                                            label={Tr("project_name")}
                                            formikProps={formikProps}
                                            disabled={working}
                                            limit={200}
                                        />

                                    </>

                                )}
                            </Form>

                        </>
                }
            </div>
        </Dialog>
    )
}

PapersGeneratorGzmManagementResolution.propTypes = {
    groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired,
    paper: PropTypes.object.isRequired
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(PapersGeneratorGzmManagementResolution);